import React from 'react';
import { Box, Container, Typography, Stack, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {

  return (
    <Box sx={{ bgcolor: 'primary.main', color: 'white', mt: 8, py: 1.5 }}>
      <Container>
        {/* Policy links + credit line */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 1,
            py: 0.5,
          }}
        >
          <Stack direction="row" spacing={1.5} flexWrap="wrap">
            <MuiLink
              component={Link}
              to="/privacy-policy"
              color="inherit"
              underline="hover"
              sx={{ fontSize: '0.75rem' }}
            >
              Privacy Policy
            </MuiLink>
            <MuiLink
              component={Link}
              to="/terms"
              color="inherit"
              underline="hover"
              sx={{ fontSize: '0.75rem' }}
            >
              Terms &amp; Conditions
            </MuiLink>
            <MuiLink
              component={Link}
              to="/event-marketing-policy"
              color="inherit"
              underline="hover"
              sx={{ fontSize: '0.75rem' }}
            >
              Event &amp; Marketing Policy
            </MuiLink>
          </Stack>
          <Stack spacing={0.1} alignItems={{ xs: 'flex-start', sm: 'flex-end' }}>
            <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
              © {new Date().getFullYear()} Evenza Events &amp; Marketing. All rights reserved.
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
              Developed and managed by <MuiLink href="https://saarkaar-in.vercel.app/#/portfolio" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">@Saarkaar.in</MuiLink>
            </Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

